<template>
   <div class="about">

    <div class="p-2 m-2 d-flex justify-content-around">
                <img
                    src="@/assets/images/defaults/logo_large_bn.png"
                    height="180"
                    alt="Alor Feri logo"
                />



                <img
                    src="@/assets/images/defaults/af_mobile_app.png"
                    height="200"
                    alt="Alor Feri Mobile Library"
                />

                <img
                    src="@/assets/images/defaults/af_model_car.png"
                    height="200"
                    alt="Alor Feri Mobile Library"
                />


            </div>

        <p style="text-align:justify">
            <span style="font-weight:bold">
                আলোর ফেরী
            </span>

            হল একটি উদ্ভাবনী অন-ডিমান্ড বই শেয়ারিং পরিষেবা যা মানুষের বই অ্যাক্সেস এবং শেয়ার করার পদ্ধতিতে বিপ্লব ঘটায়। এর মোবাইল লাইব্রেরি মডেল এবং ব্যবহারকারী-বান্ধব অ্যাপের মাধ্যমে, আলোর ফেরি পাঠকদের সংযুক্ত করে, জ্ঞান ভাগ করে নেওয়ার প্রচার করে এবং পাঠের সংস্কৃতিকে উৎসাহিত করে। প্ল্যাটফর্মটি সীমিত বইয়ের প্রাপ্যতার চ্যালেঞ্জ মোকাবেলা করে বিভিন্ন ধরনের বইয়ের সহজ অ্যাক্সেস প্রদান করে, পড়াকে আরও সুবিধাজনক এবং সাশ্রয়ী করে। আলোর ফেরি স্থায়িত্বকে অগ্রাধিকার দেয়, পরিবেশ বান্ধব অনুশীলন যেমন সোলার প্যানেল এবং জিপিএস-সক্ষম মোবাইল লাইব্রেরি অন্তর্ভুক্ত করে। প্ল্যাটফর্মের প্রভাব স্থানীয় পাড়া, শিক্ষা প্রতিষ্ঠান এবং গ্রামীণ এলাকা সহ বিভিন্ন সম্প্রদায়ের মধ্যে প্রসারিত হয়, ব্যক্তিদের জ্ঞানের সাথে ক্ষমতায়ন করে এবং শিক্ষার সুযোগ বৃদ্ধি করে। এর পরিমাপযোগ্য এবং প্রতিলিপিযোগ্য মডেলের সাথে, আলোর ফেরির লক্ষ্য দেশব্যাপী তার পরিষেবাগুলি প্রসারিত করা, যাতে সারা দেশে বইগুলি মানুষের কাছে অ্যাক্সেসযোগ্য হয়। উদ্ভাবন, সামাজিক প্রভাব, এবং পরিবেশগত সচেতনতার প্রতি সংগঠনের প্রতিশ্রুতি এটিকে আলাদা করে, আলোর ফেরি বই ভাগাভাগি এবং জ্ঞান প্রচারের জগতে একটি রূপান্তরকারী শক্তি তৈরি করে।

        </p>

        <p>
            <b>
                ভিশন:
            </b>

            <br />

বইগুলিকে সকলের কাছে, যে কোনও সময় এবং যে কোনও জায়গায় অ্যাক্সেসযোগ্য করে তোলার জন্য, এমন একটি বিশ্বকে গড়ে তোলা যেখানে জ্ঞানের কোনও সীমানা নেই৷
        </p>


        <p style="text-align:justify">
            <b> মিশন:</b>
            <br />

পাঠকদের সংযুক্ত করতে, জ্ঞান ভাগ করে নিতে এবং বইগুলির একটি বিস্তৃত পরিসরে সহজ এবং সাশ্রয়ী মূল্যের অ্যাক্সেস প্রদান করে পড়ার প্রতি অনুপ্রাণিত করতে।
        </p>


        <p>
            <b>
                লক্ষ্য:
            </b>

            <br />


            <ul>

                <li>
                    বইয়ের বিভিন্ন পরিসরে সহজে প্রবেশাধিকার প্রদান।
                </li>

                <li>
                    পঠন এবং জ্ঞান চর্চার সংস্কৃতি গড়ে তোলা।
                </li>

                <li>
                    সাক্ষরতা এবং শিক্ষাগত উন্নয়ন প্রচার।
                </li>

                <li>
                    বইপ্রেমীদের সাথে বইয়ের দূরত্ব কমানো।
                </li>

                <li>
                    সকলের জন্য পড়া সুবিধাজনক, সাশ্রয়ী এবং আনন্দদায়ক করা।
                </li>
            </ul>
        </p>

    </div>
</template>

<script>

export default {
    name: "AboutBn",
    components: {},
    props: {},
    mounted: function() {},

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
